"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const translate_1 = require("./translate");
const OnlyAvailableAtHotmartClub = ({ t }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "_mt-4 _mb-5 _p-2 _d-flex _align-items-center \\\n      _align-self-center _bg-blue-lightest _rounded _text-1 _text-gray-600", children: [(0, jsx_runtime_1.jsx)("span", { className: "_w-5 _h-5 _mr-2 _p-0 _text-2 _text-center _bg-blue-lighter _rounded", children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['far', 'lock'] }) }), (0, jsx_runtime_1.jsx)("p", { className: "_m-0", children: t('cta.availability') })] }));
};
exports.default = (0, translate_1.translate)()(OnlyAvailableAtHotmartClub);
